/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  MyRaffleEntries,
  MyRaffleEntriesParams,
  Raffle,
  RaffleClaim,
  RaffleClaimInput,
  RaffleEntrants,
  RaffleEntrantsParams,
  RaffleEntryInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary My raffle entries
 */
export const myRaffleEntries = (
    params?: MaybeRefOrGetter<MyRaffleEntriesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<MyRaffleEntries>(
      {url: `/my-raffle-entries`, method: 'GET',
        params, signal
    },
      );
    }




export const getMyRaffleEntriesQueryKey = (params?: MaybeRefOrGetter<MyRaffleEntriesParams>,) => {
    return [
    'my-raffle-entries', ...(params ? [params] : [])
    ] as const;
    }


export const getMyRaffleEntriesQueryOptions = <TData = Awaited<ReturnType<typeof myRaffleEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<MyRaffleEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myRaffleEntries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMyRaffleEntriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof myRaffleEntries>>> = ({ signal }) => myRaffleEntries(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof myRaffleEntries>>, TError, TData>
}

export type MyRaffleEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof myRaffleEntries>>>
export type MyRaffleEntriesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary My raffle entries
 */

export function useMyRaffleEntries<TData = Awaited<ReturnType<typeof myRaffleEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<MyRaffleEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myRaffleEntries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMyRaffleEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Claim a raffle prize with the link from the claim mail
 */
export const claimRafflePrize = (
    raffleClaimInput: MaybeRefOrGetter<RaffleClaimInput>,
 signal?: AbortSignal
) => {
      raffleClaimInput = toValue(raffleClaimInput);

      return axiosClient<RaffleClaim>(
      {url: `/raffle-claims`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: raffleClaimInput, signal
    },
      );
    }




export const getClaimRafflePrizeMutationKey = () => ['claimRafflePrize'] as const;

export const getClaimRafflePrizeMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimRafflePrize>>, TError,ClaimRafflePrizeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof claimRafflePrize>>, TError,ClaimRafflePrizeMutationVariables, TContext> => {

const mutationKey = getClaimRafflePrizeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimRafflePrize>>, ClaimRafflePrizeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  claimRafflePrize(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClaimRafflePrizeMutationResult = NonNullable<Awaited<ReturnType<typeof claimRafflePrize>>>
    export type ClaimRafflePrizeMutationBody = RaffleClaimInput
    export type ClaimRafflePrizeMutationError = ErrorType<ValidationError | StandardError>
    export type ClaimRafflePrizeMutationVariables = {data: RaffleClaimInput}

    /**
 * @summary Claim a raffle prize with the link from the claim mail
 */
export const useClaimRafflePrize = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimRafflePrize>>, TError,ClaimRafflePrizeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof claimRafflePrize>>,
        TError,
        ClaimRafflePrizeMutationVariables,
        TContext
      > => {
      return useMutation(getClaimRafflePrizeMutationOptions(options), queryClient);
    }
    /**
 * @summary Current Raffle
 */
export const currentRaffle = (

 signal?: AbortSignal
) => {


      return axiosClient<Raffle>(
      {url: `/raffles/current`, method: 'GET', signal
    },
      );
    }




export const getCurrentRaffleQueryKey = () => {
    return [
    'raffles','current'
    ] as const;
    }


export const getCurrentRaffleQueryOptions = <TData = Awaited<ReturnType<typeof currentRaffle>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentRaffle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCurrentRaffleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentRaffle>>> = ({ signal }) => currentRaffle(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof currentRaffle>>, TError, TData>
}

export type CurrentRaffleQueryResult = NonNullable<Awaited<ReturnType<typeof currentRaffle>>>
export type CurrentRaffleQueryError = ErrorType<StandardError>


/**
 * @summary Current Raffle
 */

export function useCurrentRaffle<TData = Awaited<ReturnType<typeof currentRaffle>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentRaffle>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentRaffleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Raffle Preview
 */
export const rafflePreview = (
    token: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      token = toValue(token);

      return axiosClient<Raffle>(
      {url: `/raffles/preview/${token}`, method: 'GET', signal
    },
      );
    }




export const getRafflePreviewQueryKey = (token: MaybeRefOrGetter<string>,) => {
    return [
    'raffles','preview',token
    ] as const;
    }


export const getRafflePreviewQueryOptions = <TData = Awaited<ReturnType<typeof rafflePreview>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rafflePreview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getRafflePreviewQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rafflePreview>>> = ({ signal }) => rafflePreview(token, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(token) !== null && toValue(token) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rafflePreview>>, TError, TData>
}

export type RafflePreviewQueryResult = NonNullable<Awaited<ReturnType<typeof rafflePreview>>>
export type RafflePreviewQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Raffle Preview
 */

export function useRafflePreview<TData = Awaited<ReturnType<typeof rafflePreview>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 token: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rafflePreview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRafflePreviewQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Raffle
 */
export const raffle = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Raffle>(
      {url: `/raffles/${id}`, method: 'GET', signal
    },
      );
    }




export const getRaffleQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'raffles',id
    ] as const;
    }


export const getRaffleQueryOptions = <TData = Awaited<ReturnType<typeof raffle>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getRaffleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof raffle>>> = ({ signal }) => raffle(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof raffle>>, TError, TData>
}

export type RaffleQueryResult = NonNullable<Awaited<ReturnType<typeof raffle>>>
export type RaffleQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Raffle
 */

export function useRaffle<TData = Awaited<ReturnType<typeof raffle>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffle>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRaffleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Raffle entrants
 */
export const raffleEntrants = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RaffleEntrantsParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<RaffleEntrants>(
      {url: `/raffles/${id}/entrants`, method: 'GET',
        params, signal
    },
      );
    }




export const getRaffleEntrantsQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RaffleEntrantsParams>,) => {
    return [
    'raffles',id,'entrants', ...(params ? [params] : [])
    ] as const;
    }


export const getRaffleEntrantsQueryOptions = <TData = Awaited<ReturnType<typeof raffleEntrants>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RaffleEntrantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffleEntrants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getRaffleEntrantsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof raffleEntrants>>> = ({ signal }) => raffleEntrants(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof raffleEntrants>>, TError, TData>
}

export type RaffleEntrantsQueryResult = NonNullable<Awaited<ReturnType<typeof raffleEntrants>>>
export type RaffleEntrantsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Raffle entrants
 */

export function useRaffleEntrants<TData = Awaited<ReturnType<typeof raffleEntrants>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RaffleEntrantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffleEntrants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRaffleEntrantsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Enter Raffle
 */
export const enterRaffle = (
    raffleId: MaybeRefOrGetter<string>,
    raffleEntryInput: MaybeRefOrGetter<RaffleEntryInput>,
 signal?: AbortSignal
) => {
      raffleId = toValue(raffleId);
raffleEntryInput = toValue(raffleEntryInput);

      return axiosClient<Raffle>(
      {url: `/raffles/${raffleId}/entry`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: raffleEntryInput, signal
    },
      );
    }




export const getEnterRaffleMutationKey = () => ['enterRaffle'] as const;

export const getEnterRaffleMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enterRaffle>>, TError,EnterRaffleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enterRaffle>>, TError,EnterRaffleMutationVariables, TContext> => {

const mutationKey = getEnterRaffleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enterRaffle>>, EnterRaffleMutationVariables> = (props) => {
          const {raffleId,data} = props ?? {};

          return  enterRaffle(raffleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnterRaffleMutationResult = NonNullable<Awaited<ReturnType<typeof enterRaffle>>>
    export type EnterRaffleMutationBody = RaffleEntryInput
    export type EnterRaffleMutationError = ErrorType<ValidationError | StandardError>
    export type EnterRaffleMutationVariables = {raffleId: string;data: RaffleEntryInput}

    /**
 * @summary Enter Raffle
 */
export const useEnterRaffle = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enterRaffle>>, TError,EnterRaffleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enterRaffle>>,
        TError,
        EnterRaffleMutationVariables,
        TContext
      > => {
      return useMutation(getEnterRaffleMutationOptions(options), queryClient);
    }
    /**
 * @summary Withdraw from Raffle
 */
export const withdrawFromRaffle = (
    raffleId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      raffleId = toValue(raffleId);

      return axiosClient<Raffle>(
      {url: `/raffles/${raffleId}/entry`, method: 'DELETE', signal
    },
      );
    }




export const getWithdrawFromRaffleMutationKey = () => ['withdrawFromRaffle'] as const;

export const getWithdrawFromRaffleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawFromRaffle>>, TError,WithdrawFromRaffleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof withdrawFromRaffle>>, TError,WithdrawFromRaffleMutationVariables, TContext> => {

const mutationKey = getWithdrawFromRaffleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawFromRaffle>>, WithdrawFromRaffleMutationVariables> = (props) => {
          const {raffleId} = props ?? {};

          return  withdrawFromRaffle(raffleId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WithdrawFromRaffleMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawFromRaffle>>>

    export type WithdrawFromRaffleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type WithdrawFromRaffleMutationVariables = {raffleId: string}

    /**
 * @summary Withdraw from Raffle
 */
export const useWithdrawFromRaffle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawFromRaffle>>, TError,WithdrawFromRaffleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof withdrawFromRaffle>>,
        TError,
        WithdrawFromRaffleMutationVariables,
        TContext
      > => {
      return useMutation(getWithdrawFromRaffleMutationOptions(options), queryClient);
    }
